import { engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { Symbols } from "../Symbols";
import { Machine } from "../Machine";
import { WinAnimator } from "../WinAnimator";
import { FreespinsController } from "./FreespinsController";
import { GameManager } from "../../Managers/GameManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { DataManager } from "../../Managers/DataManager";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { BaseView } from "../Base/BaseView";
import { Tweens } from "../../Components/Effects/Tweens";
import { ImageTextCounterElement } from "../../Components/Elements/Texts/ImageTextCounterElement";
import { Languages } from "../../Utils/Languages";
import { AmbientBackground } from "../../Utils/AmbientBackground";
import { WinAnimatorExtended } from "../../CustomComponents/WinAnimatorExtended";
import { MachineExtended } from "../../CustomComponents/MachineExtended";
import { Settings } from "../../CustomComponents/Settings";
import { PaylinesExtended } from "../../CustomComponents/PaylinesExtended";
import { LayoutContainerElement } from "../../CustomComponents/LayoutContainerElement";
import { ClockCounter, ClockCounterStartOptions } from "../../CustomComponents/ClockCounter";
import { ClockSelector } from "../../CustomComponents/ClockSelector";
import { Symbol } from "../Symbol";
import { LayoutManager } from "../../Managers/LayoutManager";
import { TimelineElement } from "../../Components/Elements/Graphics/TimelineElement";
import { GroupTweens } from "../../CustomComponents/GroupTweens";
import { ModuleManager } from "../../Managers/ModuleManager";

@engineComponent(ComponentTypes.DisplayObject)
export class FreespinsView extends LayoutContainerElement {
    static FsMessageBox: SwitchElement;

    private _controller: FreespinsController;
    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;
    private _outroSoundDelay: FrameTimerEventEmitter;
    private _outroDelayFinally: FrameTimerEventEmitter;
    private _paylines: PaylinesExtended;
    private _symbols: Symbols;
    private _machine: MachineExtended;
    private _winAnimator: WinAnimatorExtended;
    private _fsMessageStart: HTMLElement;
    private _fsMessageEnd: HTMLElement;
    private _fsMessageEndNoWin: HTMLElement;

    private fsCounter: SwitchElement;
    private mpCounter: SwitchElement;

    private bonusSelector: ClockSelector;

    private bonusCounter: ClockCounter;
    private clockSequence: ClockCounterStartOptions[] = [];
    private clockEndWithFinishWins = false;
    private _counterDelay: FrameTimerEventEmitter;

    private splashScreenDuration = 120;

    private bonuses: number = 0;
    public static LastMultiplier: number = 0;
    public static Multiplier: number = 0;
    public static FSCount: number = 0;

    private totalWin: TimelineElement;
    private totalWinNoWin: TimelineElement;
    private fsMessage: TimelineElement;

    private groupTweens: SwitchElement;
    private groupTweensPortrait: SwitchElement;

    constructor() {
        super();
        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));
        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));
        this._outroSoundDelay = CreateFrameTimer("outroSoundDelay");
        this._outroSoundDelay.on(FrameTimerEvents.Complete, this.outroSound.bind(this));
        this._outroDelayFinally = CreateFrameTimer("outroFinally");
        this._outroDelayFinally.on(FrameTimerEvents.Complete, this.outroFinally.bind(this));
        this._counterDelay = CreateFrameTimer("counterDelay");
        this._counterDelay.on(FrameTimerEvents.Complete, this.startClockCounter.bind(this, true));
    }

    public create(node: Element): void {
        super.create(node);
        if (this.childs["Symbols"] != null) {
            this._symbols = this.childs["Symbols"];
            this.removeChild(this._symbols);
        }
        if (this.childs["Paylines"] != null) this._paylines = this.childs["Paylines"];
        if (this.childs["Machine"] != null) this._machine = this.childs["Machine"];
        if (this.childs["WinAnimator"] != null) this._winAnimator = this.childs["WinAnimator"];
        if (this.childs["TotalWin"] != null) {
            this.totalWin = this.childs["TotalWin"];
            this.totalWin.on("finished", this.totalWinFinished.bind(this));
            this.totalWin.on(TimelineElement.AnimationComplete, this.totalWinComplete.bind(this));
            this.totalWin.visible = false;
        }
        if (this.childs["TotalWinNoWin"] != null) {
            this.totalWinNoWin = this.childs["TotalWinNoWin"];
            this.totalWinNoWin.on("finished", this.totalWinFinished.bind(this));
            this.totalWinNoWin.on(TimelineElement.AnimationComplete, this.totalWinComplete.bind(this));
            this.totalWinNoWin.visible = false;
        }
        if (this.childs["FSMessage"] != null) {
            this.fsMessage = this.childs["FSMessage"];
            this.fsMessage.visible = false;
        }
        if (this.childs["GroupTweens"] != null) this.groupTweens = this.childs["GroupTweens"];
        if (this.childs["GroupTweensPortrait"] != null) this.groupTweensPortrait = this.childs["GroupTweensPortrait"];

        this._winAnimator.isFS = true;

        this._fsMessageStart = document.getElementById("fsMessageStart");
        this._fsMessageEnd = document.getElementById("fsMessageEnd");
        this._fsMessageEndNoWin = document.getElementById("fsMessageEndNoWin");

        //prevent first animation on page load
        if (this._fsMessageStart) {
            this._fsMessageStart.classList.add("_noAnim");
        }
        this._fsMessageEnd.classList.add("_noAnim");
        this._fsMessageEndNoWin.classList.add("_noAnim");

        if (this.childs["FsMessageBox"] != null) FreespinsView.FsMessageBox = this.childs["FsMessageBox"];

        if (this.childs["CounterFS"] != null) this.fsCounter = this.childs["CounterFS"];
        if (this.childs["CounterMultiplier"] != null) this.mpCounter = this.childs["CounterMultiplier"];

        for (let key in this.childs) {
            const item = this.childs[key];
            if (item instanceof ClockCounter) {
                this.bonusCounter = item;
                this.bonusCounter.on(ClockCounter.RopeFinished, this.clockStepFinished.bind(this));
            }
            if (item instanceof ClockSelector) {
                this.bonusSelector = item;
                this.bonusSelector.on(ClockSelector.SelectionFinished, this.clockSelectorFinished.bind(this));
                this.bonusSelector.on(
                    ClockSelector.MultiplierFinished,
                    function () {
                        if (this.mpCounter != null) {
                            this.updateCounterValue(this.mpCounter, "x" + FreespinsView.Multiplier.toString());
                            this.mpCounter.goToCase("POP");
                        }
                    }.bind(this),
                );
                this.bonusSelector.on(
                    ClockSelector.FSFinished,
                    function () {
                        if (this.fsCounter != null) {
                            this.updateCounterValue(this.fsCounter, FreespinsView.FSCount.toString() + "FS");
                            //this.fsCounter.goToCase('POP');
                        }
                    }.bind(this),
                );
            }
        }

        // set childs to GroupTweens object
        if (this.groupTweens) {
            let groupTweenElements: Object = this.groupTweens.getChildElements();
            if (groupTweenElements) {
                for (let key in groupTweenElements) {
                    if (groupTweenElements.hasOwnProperty(key)) {
                        if (groupTweenElements[key] instanceof GroupTweens) {
                            (<GroupTweens>groupTweenElements[key]).setChilds(this.childs);
                        }
                    }
                }
            }
        }

        // set childs to GroupTweens object
        if (this.groupTweensPortrait) {
            let groupTweenElements: Object = this.groupTweensPortrait.getChildElements();
            if (groupTweenElements) {
                for (let key in groupTweenElements) {
                    if (groupTweenElements.hasOwnProperty(key)) {
                        if (groupTweenElements[key] instanceof GroupTweens) {
                            (<GroupTweens>groupTweenElements[key]).setChilds(this.childs);
                        }
                    }
                }
            }
        }
    }

    public initReceived(controller: FreespinsController): void {
        this.renderable = false;
        this._controller = controller;
        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.freespinsResponse != null) {
                    if (
                        GameManager.freespinsResponse.initData != null &&
                        GameManager.freespinsResponse.initData.reels !== null
                    ) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(
                            this._symbols,
                            GameManager.freespinsResponse.initData.reels,
                            this._winAnimator,
                            null,
                            this.childs["Teasing"],
                        );
                    }

                    if (this._winAnimator != null) {
                        this._winAnimator.on(WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
                        this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                        this._winAnimator.initialize(
                            this._symbols,
                            this._paylines,
                            this.childs["NoWinContainer"],
                            this.childs["WinContainer"],
                            this,
                        );
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no freespin reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        this.visible = false;
    }

    private clockSelectorFinished() {
        if (this.clockSequence.length) {
            this.consumeCounterSequence();
        } else {
            if (this.clockEndWithFinishWins) {
                this._winAnimator.allSymbolsGoToCase(Symbol.CaseNormal, false);
                this._winAnimator.cycleWins(true);
                this.finalFinishWinAnimator();
            } else {
                this._winAnimator.allSymbolsGoToCase(Symbol.CaseNormal, false);
                this._winAnimator.sortSymbols();
                this._controller.winCalculationFinished();
            }
        }
    }

    public confirm() {
        /*FreespinsView.FsMessageBox.goToCase('FS_START_HIDE');*/
        /*if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.add(HtmlController.DisabledClass);
            this._fsMessageStart.classList.remove("_noAnim");
        }*/
        PlayList.stop("SND_FSWait", 30);
        this.fsMessage.goToOutro();
        this.bonusSelector.start();
        this.updateCounterValue(this.fsCounter, FreespinsView.FSCount.toString() + "FS");
        this.fsCounter.goToCase("POP");
    }

    private clockStepFinished(lastData: ClockCounterStartOptions) {
        if (lastData && lastData.lastSymbolCase) {
            this._winAnimator.currentSymbols[lastData.reelIndex][lastData.symbolIndex].goToCase(
                lastData.lastSymbolCase === "NOWIN" ? "NOWIN" : "NORMAL",
            );
        }
        if (lastData.currentClocks > 0 && lastData.currentClocks % 4 === 0) {
            let filtered = GameManager.freespinsResponse.wins.filter(
                (win) =>
                    win.trigger === Communication.Game.WinTrigger.Scatter ||
                    win.trigger === Communication.Game.WinTrigger.Custom,
            );
            let total = 0;
            let totalFS = 0;
            let index = this.clockSequence.shift().winIndex || 0;
            filtered.forEach((win, winIndex) => {
                if (winIndex === index && win.customData && win.customData.multiplier) {
                    total += win.customData.multiplier;
                }
                if (win.type === Communication.Game.WinType.freeSpins && win.customData) {
                    totalFS += win.customData.count || 0;
                }
            });
            let mul = GameManager.freespinsResponse.customData
                ? GameManager.freespinsResponse.customData.currentWildMultiplier
                : -1;
            FreespinsView.Multiplier += total ? total : mul;
            FreespinsView.FSCount += totalFS;

            this.bonusSelector.awaitStart({
                freespins: totalFS,
                multiplier: total ? total : mul,
                popOutro: true,
                delay: 60,
            });
            this.fsMessage.play(totalFS);
            this.fsMessage.visible = true;
            /*FreespinsView.FsMessageBox.goToCase('FS_START_SHOW');*/
            this._controller.confirmablefeature();
            PlayList.play("SND_BaseMessage", 0);
            PlayList.loop("SND_FSWait", 30);
            PlayList.setVolume("SND_FSLoop", 0, 15);
        } else {
            if (this.clockSequence.length) {
                this.consumeCounterSequence();
            } else {
                if (this.clockEndWithFinishWins) {
                    this._winAnimator.allSymbolsGoToCase(Symbol.CaseNormal, false);
                    this._winAnimator.cycleWins(true);
                    this.finalFinishWinAnimator();
                } else {
                    this._winAnimator.allSymbolsGoToCase(Symbol.CaseNormal, false);
                    this._winAnimator.sortSymbols();
                    this._controller.winCalculationFinished();
                }
            }
        }
    }

    private consumeCounterSequence() {
        const item = this.clockSequence.shift();
        const symbol = this._winAnimator.currentSymbols[item.reelIndex][item.symbolIndex];
        item.lastSymbolCase = symbol.getCurrentCase();
        symbol.goToCase("ADD");
        this.bonusCounter.start(item);
    }

    private startClockCounter(endWithFinishWins: boolean = false): boolean {
        this.clockEndWithFinishWins = endWithFinishWins;
        let bFrom = this.bonuses;
        let bTo = bFrom;
        this.clockSequence = [];
        let windex = 0;
        GameManager.freespinsResponse.screen.reels.forEach((reel, reelIndex) => {
            reel.symbols.forEach((symbol, symbolIndex) => {
                if (symbol === Settings.SymbolBonus) {
                    bTo++;
                    this.clockSequence.push({ currentClocks: bTo, reelIndex: reelIndex, symbolIndex: symbolIndex });
                    if (bTo % 4 === 0) {
                        this.clockSequence.push({
                            currentClocks: bTo,
                            reelIndex: reelIndex,
                            symbolIndex: symbolIndex,
                            winIndex: windex++,
                        });
                    }
                }
            });
        });
        this.bonuses = bTo;
        if (this.clockSequence.length) {
            this._winAnimator.allSymbolsGoToCase(Symbol.CaseNowin, true);
            this._winAnimator.currentSymbols.forEach((reel) => {
                reel.forEach((symbol) => {
                    if (symbol.id === Settings.SymbolBonus - 1) {
                        symbol.goToCase(Symbol.CaseNormal);
                    }
                });
            });
            this._winAnimator.sortSymbols();
            this.consumeCounterSequence();
            return true;
        }
        if (this.clockEndWithFinishWins) {
            this.finalFinishWinAnimator();
        }
        return false;
    }

    public startReceived(): void {
        FreespinsView.Multiplier = GameManager.freespinsResponse.customData
            ? GameManager.freespinsResponse.customData.currentWildMultiplier
            : -1;
        /*if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.add(HtmlController.DisabledClass);
            this._fsMessageStart.classList.remove("_noAnim");
        }*/
        this.fsMessage.goToOutro();
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.reset(true);
    }

    public spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._machine.spinStop(null, false, true);
    }

    public endReceived(): void {}

    public spin(): void {
        FreespinsView.FSCount = GameManager.freespinsResponse.freeSpins.remainingCount - 1;
        if (GameManager.freespinsResponse.customData) {
            this.bonuses = GameManager.freespinsResponse.customData.totalCollectedClocksCount || 0;
        }
        this.bonusCounter.setValue(this.bonuses, 0, true);
        PlayList.resetVolume("SND_FSLoop", 30);
        /*if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.add(HtmlController.DisabledClass);
            this._fsMessageStart.classList.remove("_noAnim");
        }*/

        if (this.fsCounter != null) {
            this.updateCounterValue(
                this.fsCounter,
                (GameManager.freespinsResponse.freeSpins.remainingCount - 1).toString() + "FS",
            );
            //this.fsCounter.goToCase('POP');
        }

        this._machine.spinStart(this._winAnimator.reset(true, true), true, this._winAnimator.currentSymbols);
    }

    public stop(): void {
        this._machine.spinStop(null, true);
    }

    public interrupt(): void {
        this._winAnimator.interruptAnimations();
        if (this.bonusCounter != null) {
            this._counterDelay.start(90);
        }
    }

    public initIntro(): void {
        this.renderable = true;
        AmbientBackground.changeAmbientBackground("fs", 0);

        if (LayoutManager.isPortrait) {
            this.groupTweensPortrait.goToCase("BASE");
        } else {
            this.groupTweens.goToCase("BASE");
        }

        if (this.childs["SplashScreen"] != null) {
            Tweens.removeTweens(this.childs["SplashScreen"]);
            this.childs["SplashScreen"].alpha = 0;
        }

        if (this.fsCounter != null) {
            FreespinsView.FSCount = GameManager.freespinsResponse.freeSpins.remainingCount;
            this.updateCounterValue(
                this.fsCounter,
                GameManager.freespinsResponse.freeSpins.remainingCount.toString() + "FS",
            );
            this.fsCounter.goToCase("INIT");
        }

        let currentMultipliers = 0;
        if (GameManager.freespinsResponse.wins) {
            GameManager.freespinsResponse.wins.forEach((win) => {
                if (win.type === Communication.Game.WinType.freeSpins && win.customData && win.customData.multiplier) {
                    currentMultipliers += win.customData.multiplier;
                }
            });
        }

        if (this.mpCounter != null) {
            FreespinsView.Multiplier = GameManager.freespinsResponse.customData
                ? GameManager.freespinsResponse.customData.currentWildMultiplier
                : -1;
            FreespinsView.LastMultiplier = FreespinsView.Multiplier - currentMultipliers;
            this.updateCounterValue(this.mpCounter, "x" + FreespinsView.Multiplier.toString());
            this.mpCounter.goToCase("INIT");
        }

        if (this.bonusCounter != null) {
            if (
                GameManager.freespinsResponse.customData &&
                GameManager.freespinsResponse.customData.totalCollectedClocksCount
            ) {
                this.bonuses = GameManager.freespinsResponse.customData.totalCollectedClocksCount;
            }
            this.bonusCounter.setValue(this.bonuses, 0, true);
        }

        FreespinsView.Multiplier = FreespinsView.LastMultiplier;
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        FreespinsView.Multiplier = GameManager.freespinsResponse.customData
            ? GameManager.freespinsResponse.customData.currentWildMultiplier
            : -1;

        this._winAnimator.showInitWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin);
        this.visible = true;
        this.retrigger();

        if (this.isLastFreespin()) {
            PlayList.setVolume("SND_BaseWinline", 0);
            PlayList.setVolume("SND_FSLoop", 0, 30);
            if (!GameManager.freespinsResponse.totalWin) {
                this.totalWinNoWin.play(0);
                this.totalWinNoWin.goToOutro(GameManager.freespinsResponse.totalWin || 0, true);
                this.totalWinNoWin.visible = true;
            } else {
                this.totalWin.play(GameManager.freespinsResponse.totalWin || 0);
                this.totalWin.goToOutro(GameManager.freespinsResponse.totalWin || 0, true);
                this.totalWin.visible = true;
            }
        } else {
            PlayList.resetVolume("SND_FSLoop", 30);
        }
    }

    public intro(long: boolean = false): void {
        this.renderable = true;
        this.bonusCounter.setValue(0, 0, true);
        this.visible = true;

        if (LayoutManager.isPortrait) {
            this.groupTweensPortrait.goToCase("INTRO");
        } else {
            this.groupTweens.goToCase("INTRO");
        }

        //PlayList.stop('SND_FSWait', 30);
        //PlayList.play('SND_FSTransIn');

        if (this.fsCounter != null) {
            FreespinsView.FSCount = GameManager.freespinsResponse.freeSpins.remainingCount;
            this.updateCounterValue(
                this.fsCounter,
                GameManager.freespinsResponse.freeSpins.remainingCount.toString() + "FS",
            );
            this.fsCounter.goToCase("INTRO");
        }

        if (this.mpCounter != null) {
            FreespinsView.Multiplier = GameManager.freespinsResponse.customData
                ? GameManager.freespinsResponse.customData.currentWildMultiplier
                : -1;
            FreespinsView.LastMultiplier = FreespinsView.Multiplier;
            this.updateCounterValue(this.mpCounter, "x" + FreespinsView.Multiplier.toString());
            this.mpCounter.goToCase("INTRO");
        }

        if (this.childs["Paylines"] != null) {
            Tweens.removeTweens(this.childs["Paylines"]);
            this.childs["Paylines"].alpha = 1;
        }

        this.alpha = 1;

        /*
        for(let key in this.childs) {
            if(key !== "MachineMask" && !(this.childs[key] instanceof ClockSelector)) {
                Tweens.removeTweens(this.childs[key]);
                Tweens.alphaTween(this.childs[key], {
                    alphas: [0, 1],
                    tweenDuration: 30
                });
            }
        }
        */

        if (this.childs["SplashScreen"] != null) {
            Tweens.removeTweens(this.childs["SplashScreen"]);
            Tweens.alphaTween(this.childs["SplashScreen"], {
                alphas: [0, 1, 1, 0],
                keyTimes: [0, 0.15, 0.85, 1],
                tweenDuration: this.splashScreenDuration,
            });
        }

        this.clockEndWithFinishWins = true;
        let bFrom = this.bonuses;
        let bTo = bFrom;
        this.clockSequence = [];
        let windex = 0;
        GameManager.freespinsResponse.screen.reels.forEach((reel, reelIndex) => {
            reel.symbols.forEach((symbol, symbolIndex) => {
                if (symbol === Settings.SymbolBonus) {
                    bTo++;
                    this.clockSequence.push({ currentClocks: bTo, reelIndex: reelIndex, symbolIndex: symbolIndex });
                    if (bTo % 4 === 0) {
                        this.clockSequence.push({
                            currentClocks: bTo,
                            reelIndex: reelIndex,
                            symbolIndex: symbolIndex,
                            winIndex: windex++,
                        });
                    }
                }
            });
        });
        this.bonuses = bTo;

        //this.bonusSelector.goToCase("OUTRO");

        this.bonusSelector.start({
            freespins: GameManager.freespinsResponse.freeSpins.totalCount,
            multiplier: GameManager.freespinsResponse.customData
                ? GameManager.freespinsResponse.customData.currentWildMultiplier || 0
                : 0,
            delay: this.splashScreenDuration,
        });

        //this._introDelay.start(this.splashScreenDuration + this.clockAnimationDuration);
    }

    public outro(): void {
        if (!GameManager.freespinsResponse.totalWin) {
            this.totalWinNoWin.goToOutro();
        } else {
            this.totalWin.goToOutro();
        }

        if (LayoutManager.isPortrait) {
            this.groupTweensPortrait.goToCase(GroupTweens.CaseBaseToGamble);
        } else {
            this.groupTweens.goToCase(GroupTweens.CaseBaseToGamble);
        }

        this.visible = true;
        Tweens.removeTweens(this);
        Tweens.alphaTween(this, {
            alphas: [1, 0],
            tweenDuration: 30,
            tweenDelay: 60,
            callbackFunction: function () {
                this.totalWin.visible = false;
                this.visible = false;
            }.bind(this),
        });

        if (this.childs["Paylines"] != null) {
            Tweens.removeTweens(this.childs["Paylines"]);
            this.childs["Paylines"].alpha = 0;
        }

        PlayList.setVolume("SND_FSLoop", 0);
        PlayList.stop("SND_FSWait", 30);
        PlayList.stop("SND_FSEndWait");
        PlayList.play("SND_FSTransOut");

        AmbientBackground.changeAmbientBackground("base", 60);
        this._outroSoundDelay.start(15);
        this._outroDelay.start(90);
    }

    private outroSound(): void {
        PlayList.play("SND_FSTransIn");
    }

    public disableLogo(): void {
        if (this.childs["Logo"] != null) {
            this.removeChild(this.childs["Logo"]);
        }
    }

    public enable(): void {
        PlayList.play("SND_FSWin");
        PlayList.play("SND_VOCFSWin");

        /*BaseView.FsMessageBox.goToCase('FS_START_SHOW');*/
        /*if (this._fsMessageStart != null && this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this.updateFsMessageStartText();
            this._fsMessageStart.classList.remove(HtmlController.DisabledClass);
            this._fsMessageStart.classList.remove("_noAnim");
        }*/
        /*
        this.fsMessage.play(GameManager.freespinsResponse.freeSpins.totalCount);
        this.fsMessage.visible = true;
        */
        this.bonusSelector.awaitOutro({
            freespins: GameManager.freespinsResponse.freeSpins.totalCount,
            multiplier: GameManager.freespinsResponse.customData
                ? GameManager.freespinsResponse.customData.currentWildMultiplier || 0
                : 0,
        });
    }

    private onReelStopped(): void {
        /*
        if (this.bonusCounter != null) {
            this.startClockCounter();
        }
         */
        this._winAnimator.onReelStopped(GameManager.freespinsResponse.screen.reels, this._machine.actualReelStopped);
    }

    private machineStopped(): void {
        this._controller.machineStopped();
        if (!GameManager.freespinsResponse.wins.length) {
            if (this.startClockCounter(true)) {
                return;
            }
        }
        if (this._winAnimator.showWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin)) {
            PlayList.setVolume("SND_FSLoop", 0);
            if (
                GameManager.freespinsResponse.screen.reels.filter(
                    (reel) => reel.symbols.filter((symbol) => symbol === Settings.SymbolBonus).length,
                ).length > 0 &&
                GameManager.freespinsResponse.currentWin > 0
            ) {
                this._controller.skippableFeature();
            }
        }
        if (GameManager.freespinsResponse.currentWin === 0) {
            if (this.isLastFreespin()) {
                // nop
            }
        }
    }

    private finishQuickWinCalculation(): void {
        this._controller.quickWinCalculationFinished();
    }

    private finishWinCalculation(): void {
        this._controller.winCalculationFinished();
    }

    private finishWinAnimator(): void {
        if (!this.startClockCounter(true)) {
            this._winAnimator.cycleWins(true);
        }
    }

    private finalFinishWinAnimator(): void {
        let old = FreespinsView.Multiplier;
        FreespinsView.Multiplier = GameManager.freespinsResponse.customData
            ? GameManager.freespinsResponse.customData.currentWildMultiplier
            : -1;
        this.updateCounterValue(this.mpCounter, "x" + FreespinsView.Multiplier.toString());
        if (old !== FreespinsView.Multiplier) {
            this.mpCounter.goToCase("POP");
        }

        this._controller.allWinsFinished();
        if (this.isLastFreespin()) {
            PlayList.setVolume("SND_BaseWinline", 0);
            PlayList.setVolume("SND_FSLoop", 0, 30);
            if (!GameManager.freespinsResponse.totalWin) {
                this.totalWinNoWin.play(0);
                this.totalWinNoWin.visible = true;
            } else {
                this.totalWin.play(GameManager.freespinsResponse.totalWin || 0);
                this.totalWin.visible = true;
            }
        } else {
            PlayList.resetVolume("SND_FSLoop", 30);
        }
        this.retrigger();
    }

    private introFinished(): void {
        this.visible = true;
        if (this.bonusCounter != null) {
            if (!this.startClockCounter()) {
                this._controller.introFinished();
            }
        } else {
            this._controller.introFinished();
        }
    }

    private outroFinished(): void {
        //PlayList.play('SND_FSTransIn');
        this.visible = false;
        this._winAnimator.resetTimer();
        this._controller.outroFinished();
        this._outroDelayFinally.start(60);
        PlayList.resetVolume("SND_BaseWinline", 30);
    }

    private outroFinally(): void {
        if (FreespinsView.FsMessageBox) {
            FreespinsView.FsMessageBox.goToCase("EMPTY");
        }
        this.totalWin.visible = false;
        this.totalWinNoWin.visible = false;
        this.renderable = false;
    }

    private retrigger(): void {
        if (!this.isLastFreespin()) {
            if (GameManager.freespinsResponse.wins != null && GameManager.freespinsResponse.wins.length > 0) {
                for (let i: number = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                    if (GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Scatter) {
                        /*
                        if (this._fsMessageStart != null && this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
                            this._fsMessageStart.classList.remove(HtmlController.DisabledClass);
                        }
                        */

                        if (this.fsCounter != null) {
                            this.updateCounterValue(
                                this.fsCounter,
                                GameManager.freespinsResponse.freeSpins.remainingCount.toString() + "FS",
                            );
                            this.fsCounter.goToCase("POP");
                        }

                        /*
                        if (this.mpCounter != null) {
                            FreespinsView.Multiplier = GameManager.freespinsResponse.customData ? GameManager.freespinsResponse.customData.currentWildMultiplier : -1;
                            this.updateCounterValue(this.mpCounter, "x" + FreespinsView.Multiplier.toString());
                            this.mpCounter.goToCase('POP');
                        }
                        */
                        if (this.bonusCounter != null) {
                            this.startClockCounter();
                        }
                    }
                }
            }
        }
    }

    private isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            return true;
        }

        return (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        );
    }

    private updateCounterValue(counter: SwitchElement, value: string, elementName: string = "Amount"): void {
        if (counter != null) {
            if (counter.hasCase("TO_" + value)) {
                counter.goToCase("TO_" + value);
            }
            let n1 = counter.getChildElementByName(elementName);
            if (n1) {
                this.updateValue(<ImageTextCounterElement>n1, value);
            }
            let n2 = counter.getChildElementByName(elementName + "Blend");
            if (n2) {
                this.updateValue(<ImageTextCounterElement>n2, value);
            }
        }
    }

    private updateValue(elem: ImageTextCounterElement, value: string): void {
        elem.bitmapText.text = value;
        elem.realign();
    }

    private updateFsMessageStartText(override?: number): void {
        if (this._fsMessageStart != null) {
            const elems = this._fsMessageStart.children;

            for (let i = 0; i < elems.length; i++) {
                //FreespinsView.Multiplier = override !== undefined ? FreespinsView.Multiplier + override : GameManager.freespinsResponse.customData ? GameManager.freespinsResponse.customData.currentWildMultiplier : -1;
                elems[i].innerHTML = Languages.getRid(
                    "FS_START_MESSAGE",
                    override !== undefined
                        ? <string>override.toString()
                        : GameManager.freespinsResponse.freeSpins.totalCount.toString(),
                );
            }
        }
    }

    onLayoutChange(isPortrait: boolean): void {
        if (this.groupTweensPortrait && this.groupTweens) {
            if (isPortrait) {
                this.groupTweensPortrait.goToCase(ModuleManager.freespinsActive() ? "BASE" : "GAMBLE");
            } else {
                this.groupTweens.goToCase(ModuleManager.freespinsActive() ? "BASE" : "GAMBLE");
            }
        }
        super.onLayoutChange(isPortrait);
        const bg = this.childs["Background"];
        const splash = this.childs["SplashScreen"];
        if (!bg) {
            return;
        }
        if (isPortrait) {
            bg.scale.x = LayoutManager.HeightScale * 1.7;
            bg.scale.y = LayoutManager.HeightScale * 1.7;
            splash.scale.x = LayoutManager.HeightScale * 1.7;
            splash.scale.y = LayoutManager.HeightScale * 1.7;
        }
    }

    totalWinFinished() {
        // nop
    }

    totalWinComplete() {
        // nop
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsView.ts
 **/